module.exports = {
  selectLanguage: "Select your language",
  "en-US": "English",
  es: "Español",
  glossary: "Glossary",
  topics: "Topics",
  about: "About",
  searchPlaceholder: "What questions do you have about immigration?",
  featuredTopics: "Featured Topics",
  popularTerms: "Popular Terms",
  disclaimer:
    "This website should not take the place of a consultation with an attorney. We encourage all individuals involved with the immigration or criminal justice systems to consult with an attorney.",
  allTopics: "All Topics",
  contactTitle: "Have feedback on this website?",
  contactDisclaimer:
    "Please share any comments or feedback about how we can improve ImmigrationInfo.org. We cannot give legal advice about individual cases or provide legal representation. We need your email address to respond, but we will not share or publish it.",
  contactName: "Your name:",
  contactEmail: "Your email:",
  contactMessage: "Message:",
  contactSuccess:
    "Message sent! Someone from the Free Migration Project will be in touch shortly.",
  contactError:
    'Oops, there seems to be an issue with the site. Please reach out to someone at the <a href="https://freemigrationproject.org/contact/">Free Migration Project</a>.',
  contactSubmit: "Submit",
  relatedTerms: "Related Terms",
  viewGlossary: "View glossary",
  noSearchResults: "Nothing found – try another search!",
};
